import { Context } from "@baseline/runtime";
import * as routing from "@baseline/ui/routing/legacy";
import { RouterBuilder } from "@baseline/ui/routing/legacy";
import { ViewManager, views } from "../ui";
import { routes } from "./routes";

export namespace MainRouter
{
    export function build(context: Context): routing.Router
    {
        const viewManager = context.require(ViewManager);

        // Create builder
        const routerBuilder = RouterBuilder.create();

        routerBuilder
            // Public routes
            .when(() => true)
            .route(
                publicRouting =>
                {
                    publicRouting
                        .when(routes.landingPage).handle(
                            () => viewManager.show(views.landingPage)
                        )
                        .when(routes.tokenizationPage).handle(
                            () => viewManager.show(views.landingPage)
                        )
                }
            );

        const router = routerBuilder.build();
        return router;
    }
}
